export const VIEW_TOOLS_REPORTS_LIST = 98
export const VIEW_TOOLS_BESPOKES_LIST = 99
export const VIEW_TOOLS_BUNDLES_LIST = 100